<style lang="less">
</style>
<template>
  <div id="app" style="height:100%;width: 100%" class="iview">
    <component v-bind:is="which_to_show"></component>
  </div>
</template>

<script>
    import man from "./components/man.vue"
    import n_login from "./components/login/login.vue"
    import Cookies from "js-cookie";
    export default {
        name: 'App',
        components: {
            man,
            n_login
        },
        data() {
            return {
                which_to_show:''
            };
        },
        watch: {
            // 如果 `question` 发生改变，这个函数就会运行111
            '$store.state.app': function(val, oldVal){
                this.which_to_show = val;
                /* if(val == "man"){
                    // this.$router.push("theme");
                }else if(val == "n_login"){
                    // this.$router.push("noneroute");
                } */
            }
        },
        methods: {
            to_json:function(i){
                var script=document.createElement('script');
                script.type='text/javaScript'; 
                script.src=app_content_url[i];
                document.getElementsByTagName('head')[0].appendChild(script);
                script.onload=function(){
                    i = i+1;
                    if (i < app_content_url.length) {
                        console.log(i)
                        this.to_json(i)
                    }else{
                        console.log(i)
                        this.assignment()
                    }
                }.bind(this)//js加载完成执行方法
            },
            assignment:function(item){
                //判断是否刷新
                let name = Cookies.get("flog");
                if (name == "true") {
                    this.$store.state.app = "man";
                    this.mothods_user();
                }else{
                    this.$store.state.app = "n_login";
                }
            },
            mothods_user: function(){
                var Base64 = require('js-base64').Base64; 
                var jso  = Base64.decode(Cookies.get("user"));
                var dest = JSON.parse(jso);
                /*  */
                //记录到当前页面
                sessionStorage.setItem("flog",true);
                sessionStorage.setItem("ID",dest.id);
                sessionStorage.setItem("SSDW",dest.SSDW);
                sessionStorage.setItem("AOTHOR_ID",dest.AOTHOR_ID);
                sessionStorage.setItem("ISADMIN",dest.ISADMIN);
                sessionStorage.setItem("USERCODE",dest.USERCODE);
                sessionStorage.setItem("USERNAME",dest.USERNAME);
                sessionStorage.setItem("EXPERT",dest.EXPERT);
                var that = this;
                this.$http({
                    method: 'post',
                    url: appurl.ip + "/ylkjservice/services/hander.ashx",
                    data: {
                        UserCode:dest.username,
                        Psw:dest.password,
                        action:"list",
                    }
                })
                .then(function (success) {
                    this.$store.state.user  =  success.data;
                }.bind(this))
                .catch(function (response) {
                    this.$Message.error('请求失败查询网络是否畅通！');
                }.bind(this))
            },
        },
        mounted:function(){
            /*this.assignment();*/
            if(app_content_url.length >0){
                this.to_json(0)
            }
        },
        beforeCreate:function(){

        }
    }
</script>



// WEBPACK FOOTER //
// App.vue?4c2e8922